export const SATELLITE_REDIRECT_KEY = "clerk_satellite_redirect";
export const SATELLITE_REDIRECT_TTL_MS = 5 * 60 * 1000; // 5 min

/** Satellite domains allowed to receive post-auth redirects (must match ClerkProvider allowedRedirectOrigins) */
export const ALLOWED_REDIRECT_ORIGINS = [
  "https://app.startupfuel.com",
  "https://staging.startupfuel.com",
  "https://dev.startupfuel.com",
] as const;

export function getValidRedirectUrl(redirectUrl: string | null): string | null {
  if (!redirectUrl) return null;
  try {
    const url = new URL(redirectUrl);
    if (ALLOWED_REDIRECT_ORIGINS.includes(url.origin as (typeof ALLOWED_REDIRECT_ORIGINS)[number])) {
      return redirectUrl;
    }
  } catch {
    // Invalid URL
  }
  return null;
}
